import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import RightTimeApi from "@/API";
import Enums from "@/enums";

export default function AdminUserCompaniesTable(props) {
  const { userData, updateData,user } = props;
  const canEditUsers = props.adminPerms?.includes(Enums.ROLE_PERMS.EditUser)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.CompanyAdmin)
    || props.adminPerms?.includes(Enums.ROLE_PERMS.SystemAdmin);
  async function toggleUserCompanyAsync(e) {
    if (!canEditUsers) return;
    const companyId = parseInt(e.currentTarget.getAttribute("data-companyid"));
    var data = {
      userId: user.userId,
      companyId: companyId
    };
    var resp = await RightTimeApi.putAsync("toggleAdminUserCompanyAccess", data);
    if (resp.ok) {
      updateData();
    }
  }
  async function toggleAllUserCompaniesAsync() {
    if (!canEditUsers) return;
    if (!user?.userId || !Array.isArray(userData?.companies)) return;

    const totalCompanies = userData.companies.length;
    const checkedCount = userData.companies.filter((company) => userCompanies.includes(company.id)).length;
    const shouldEnableAll = checkedCount <= totalCompanies / 2;

    const companiesToToggle = userData.companies.filter((company) =>
      shouldEnableAll ? !userCompanies.includes(company.id) : userCompanies.includes(company.id)
    );

    if (companiesToToggle.length === 0) return;

    await Promise.all(
      companiesToToggle.map((company) =>
        RightTimeApi.putAsync("toggleAdminUserCompanyAccess", {
          userId: user.userId,
          companyId: company.id
        })
      )
    );

    updateData();
  }
  let userCompanies = [];
  if (user?.userId && userData?.adminUsers && userData.adminUsers.find(u => u.id === user.userId)) {
    userCompanies = userData.adminUsers.find(u => u.id === user.userId).companyIds;
  }
  return (
    <div className="tableWrapper factTable horizontal">
      <table>
        <caption>
          <span className="title">User/Company Access</span>
        </caption>
        <thead>
          <tr>
            <th>Company</th>
            <th
              className="toggleColumnHeader"
              onClick={toggleAllUserCompaniesAsync}
              style={{ cursor: canEditUsers ? "pointer" : "default" }}
              title={canEditUsers ? "Toggle access for all companies" : undefined}
            >
              Access
            </th>
          </tr>
        </thead>
        <tbody>
          {userData.companies.map((company) => (
            <tr key={company.id}>
              <td>{company.name}</td>
              <td
                onClick={(e) => {
                  if (canEditUsers) toggleUserCompanyAsync(e);
                }}
                data-companyid={company.id}
              >
                {userCompanies.includes(company.id) ?
                  <MdCheckBox className={`checkbox checked actionIcon${canEditUsers ? "" : " disabled"}`} /> :
                  <MdCheckBoxOutlineBlank className={`checkbox unchecked actionIcon${canEditUsers ? "" : " disabled"}`} />
                }
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
}

